import React from "react";
import "../WhyChoose.css";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

import {
    FaUserShield,
    FaClock,
    FaShieldAlt,
    FaCloud,
    FaClipboardCheck,
    FaBolt,
    FaArrowRight,
} from "react-icons/fa";

const features = [
    {
        icon: <FaUserShield />,
        title: "Certified Security Experts",
        description:
            "Our experienced cybersecurity professionals deliver enterprise-grade security solutions tailored to your business requirements and evolving threat landscape.",
    },
    {
        icon: <FaClock />,
        title: "24×7 Security Monitoring",
        description:
            "Continuous monitoring and proactive threat detection help identify and respond to cyber incidents before they impact your business.",
    },
    {
        icon: <FaShieldAlt />,
        title: "Zero Trust Security",
        description:
            "Protect users, devices, and applications with modern Zero Trust security architecture, identity verification, and least-privilege access.",
    },
    {
        icon: <FaCloud />,
        title: "Cloud & Infrastructure Protection",
        description:
            "Secure cloud environments, servers, applications, and enterprise infrastructure against today's sophisticated cyber threats.",
    },
    {
        icon: <FaClipboardCheck />,
        title: "Compliance & Risk Management",
        description:
            "Meet regulatory requirements and reduce business risks with comprehensive security assessments and compliance services.",
    },
    {
        icon: <FaBolt />,
        title: "Rapid Incident Response",
        description:
            "Our specialists quickly investigate, contain, and recover from cyber incidents to minimize downtime and business disruption.",
    },
];

const WhyChoose = () => {
    return (
        <section className="whychoose-section">

            <div className="container">

                {/* SECTION HEADING */}

                <motion.div
                    className="section-heading"
                    initial={{ opacity: 0, y: 40 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.8 }}
                >

                    <span className="section-tag">

                        Why Choose BlueLotus

                    </span>

                    <h2>

                        Trusted Cybersecurity
                        <span> Partner for Modern Businesses</span>

                    </h2>

                    <p>

                        BlueLotus Infrasafety Projects Private Limited
                        combines deep cybersecurity expertise,
                        innovative technologies, and proactive security
                        strategies to protect organizations from
                        today's rapidly evolving cyber threats.

                    </p>

                </motion.div>

                {/* FEATURE CARDS */}

                <div className="why-grid">

                    {features.slice(0, 3).map((item, index) => (

                        <motion.div
                            key={index}
                            className="why-card"
                            initial={{ opacity: 0, y: 50 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{
                                duration: .5,
                                delay: index * .15
                            }}
                        >

                            <div className="why-icon">

                                {item.icon}

                            </div>

                            <h3>

                                {item.title}

                            </h3>

                            <p>

                                {item.description}

                            </p>

                        </motion.div>

                    ))}

                    {/* SECOND ROW FEATURE CARDS */}

                    {features.slice(3, 6).map((item, index) => (

                        <motion.div
                            key={index + 3}
                            className="why-card"
                            initial={{ opacity: 0, y: 50 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{
                                duration: .5,
                                delay: index * .15
                            }}
                        >

                            <div className="why-icon">

                                {item.icon}

                            </div>


                            <h3>

                                {item.title}

                            </h3>


                            <p>

                                {item.description}

                            </p>


                        </motion.div>

                    ))}


                </div>


                {/* CTA SECTION */}

                <motion.div
                    className="why-cta"
                    initial={{ opacity: 0, y: 40 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: .7 }}
                >

                    <div className="cta-content">

                        <h3>

                            Ready to Strengthen Your Cyber Defense?

                        </h3>

                        <p>

                            Talk with our cybersecurity specialists and discover
                            how BlueLotus Infrasafety Projects Private Limited can protect your organization against
                            modern cyber threats.

                        </p>

                    </div>


                    <a href="/contact" className="cta-btn">

                        Contact Security Experts

                        <FaArrowRight />

                    </a>


                </motion.div>


            </div>

        </section>
    );
};


export default WhyChoose;